// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IsUnsubscribedRequestModel {
    static getAttributeTypeMap() {
        return IsUnsubscribedRequestModel.attributeTypeMap;
    }
}
IsUnsubscribedRequestModel.discriminator = undefined;
IsUnsubscribedRequestModel.additionalProperties = false;
IsUnsubscribedRequestModel.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
];
//# sourceMappingURL=isUnsubscribedRequestModel.js.map